import React, { useCallback } from 'react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { EditTitleFieldsModal } from '@teetsh/app/src/components/EditTitleFieldsModal';
import InputGroup from '@teetsh/app/src/components/Form/InputGroup';
import useUpdateEDT from '@teetsh/app/src/queries/edt/useUpdateEDT';
import useEDT from '@teetsh/app/src/queries/edt/useEDT';
import { updateEDTInfoPayloadAtom } from './atom';

export function UpdateEDTInfoModal() {
  const { t } = useTranslation(['emploiDuTemps', 'common']);
  const updateEDT = useUpdateEDT();
  const [edtPayload, setEdtPayload] = useAtom(updateEDTInfoPayloadAtom);

  const { data: fullEdt } = useEDT({
    edtId: edtPayload?.id || '',
    enabled: !!edtPayload?.id,
  });

  const updateField = (field: 'name' | 'subtitle', value: string) => {
    if (!edtPayload) return;
    setEdtPayload({ ...edtPayload, [field]: value });
  };

  const handleSave = useCallback(async () => {
    if (!edtPayload || !fullEdt) return;

    await updateEDT({
      edt: {
        ...fullEdt,
        name: edtPayload.name,
        subtitle: edtPayload.subtitle,
      },
    });
  }, [edtPayload, fullEdt, updateEDT]);

  return (
    <EditTitleFieldsModal
      atom={updateEDTInfoPayloadAtom}
      labels={{
        title: t('emploiDuTemps:topbar.editInformation'),
      }}
      onSave={handleSave}
    >
      <InputGroup
        id="edt-title-input"
        label={t('emploiDuTemps:topbar.titleLabel')}
        value={edtPayload?.name || ''}
        onChange={value => updateField('name', value)}
        placeholder={t('emploiDuTemps:topbar.titlePlaceholder')}
        autoFocus
        large
      />
      <InputGroup
        id="edt-subtitle-input"
        label={t('emploiDuTemps:topbar.subtitleLabel')}
        value={edtPayload?.subtitle || ''}
        onChange={value => updateField('subtitle', value)}
        placeholder={t('emploiDuTemps:topbar.subtitlePlaceholder')}
        large
      />
    </EditTitleFieldsModal>
  );
}
